import { useLayoutEffect, useRef, useState } from "react";

export default function useOverflow() {
  const [isOverflowing, setIsOverflowing] = useState<boolean>(false);
  const ref = useRef<HTMLElement | null>(null);

  useLayoutEffect(() => {
    const refCurrent = ref.current;
    const needToShowOverflow =
      refCurrent && refCurrent.clientWidth < refCurrent.scrollWidth;

    if (needToShowOverflow) {
      setIsOverflowing(true);
    }
  }, []);

  return { isOverflowing, ref };
}
